import * as z from 'zod'

export const PhoneSchema = z.object({
	phone: z.string().nonempty().min(12).max(13),
	alias: z.string().optional()
})

export type PhoneType = z.TypeOf<typeof PhoneSchema>